export default __webpack_public_path__ + "static/media/successfulicon.17fc20b5.svg";